var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container"},[_vm._m(0),_c('IconLogoShort',{attrs:{"width":"40px"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-links"},[_c('a',{attrs:{"href":"https://suportehotels.pmweb.com.br/pt/category/11","target":"_blank"}},[_vm._v(" Lets Conhecimento ")])])
}]

export { render, staticRenderFns }